import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { LogOut, User, Calendar, Users } from 'lucide-react';

const Navbar: React.FC = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <span className="text-xl font-bold text-gray-900">Vinterbadeklubbens saunagus</span>
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <Link
              to="/sessions"
              className="text-gray-700 hover:text-blue-700 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              <Calendar className="w-4 h-4 inline mr-1" />
              Sessioner
            </Link>

            {user ? (
              <>
                <Link
                  to="/gusmasters"
                  className="text-gray-700 hover:text-blue-700 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  <Users className="w-4 h-4 inline mr-1" />
                  Gusmestre
                </Link>

                <Link
                  to="/my-bookings"
                  className="text-gray-700 hover:text-blue-700 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  Mine Bookinger
                </Link>

                {user.isAdmin && (
                  <Link
                    to="/admin"
                    className="text-gray-700 hover:text-blue-700 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                  >
                    Admin
                  </Link>
                )}

                <div className="flex items-center space-x-2">
                  <div className="flex items-center text-gray-700">
                    <User className="w-4 h-4 mr-1" />
                    <span className="text-sm font-medium">{user.name}</span>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="text-gray-700 hover:text-blue-700 p-2 rounded-md transition-colors"
                    title="Log ud"
                  >
                    <LogOut className="w-4 h-4" />
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center space-x-2">
                <Link
                  to="/login"
                  className="text-gray-700 hover:text-blue-700 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  Log Ind
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 